/**!
 *
 * jQuery Selectbox
 *
 * Allows us to style the select element reliably cross browser by using
 * a span as a kind of backdrop facade.
 *
 * Depends:
 *      jQuery
 *      css to absolutely position the select and make it the same size as the wrapper and span underneath.
 *
 * Details:
 * We create a facade span and then wrap both the select and facade with a wrapper span.
 * The select is then absolutely positioned over the facade and made invisible by setting opacity:0
 * Because the select is still in the document flow we can interact with it just like normal:
 * use tabbing, attach events directly to it, etc.
 *
 *
 * The original markup looks like this:
 *
 * <select id="some_select_id" class="some-arbitrary-class">
 *     <option>options go here...</option>
 * </select>
 *
 * And afterwards looks like this:
 * note that the wrapper has the same id as the select but with the "_wrapper" suffix
 * also, any class names get copied from the original select to the wrapping span.
 *
 * <span class="select some-arbitrary-class" id="some_select_id_wrapper">
 *     <span>Selected Label</span>
 *     <select id="some_select_id">
 *         <option>options go here...</option>
 *     </select>
 * </span>
 *
 *
 * Invoke it like this:
 * $('#some_select_id').selectbox();
 *
 * Note: there are no callbacks here.
 * Just attach events to the select element like you would normally: e.g.
 *
 * $("#some_select_id").selectbox().on("change", function() {
 *      // something happens when a new value is selected
 * });
 *
 *
 * TODO: test in Opera and make sure there is graceful degradation
 * TODO: method for updating value dynamically (without triggering change event)
 * TODO: method for manipulating set of options??
 *
 **/



(function( $ ) {

    $.fn.selectbox = function(options) {
        
        var settings = $.extend({
            cssClass: "select"
        }, options);
        
        return this.each(function() {
            var $this = $(this);
            
            
//            console.log("jquery.selectbox init", $this, $this.attr('multiple'));
            
            if ( ! $this.data("selectbox") && $this.attr('multiple') == undefined ) { // only instantiate once, and skip multiselect boxes
                
                $this.data("selectbox", true);
                var init_opt = ( $('option:selected', this).length ) ? $('option:selected', this).text() : $('option', this).first().text();

                var $wrapper = ( $this.parent().is("." + settings.cssClass) ) ? $this.parent() : $('<span class="' + settings.cssClass + '"></span>');

                // copy over any classes from the select
                if ( $this.attr("class") !== undefined ) {
                    var classNames = $this.attr("class");
                    $wrapper.addClass( classNames );
                    $this.removeClass( classNames );
                }

                if ( $this.attr("id") !== undefined ) {
                    $wrapper.attr('id', $this.attr('id') + '_wrapper');
                }

                if ( ! $this.parent().is("." + settings.cssClass) ) {
                    $this.wrap($wrapper);
                }

                var $backdrop = ( $this.prev("span").length == 1 ) ? $this.prev("span") : $("<span />");
                $backdrop.html(init_opt);
                $this.before($backdrop);

                $this.css({ 'z-index':1, 'opacity':0, '-khtml-appearance':'none' })
                    .change( function() {
                        var text = $('option:selected', this).text();
                        $backdrop.text(text);
                    })
                    .focus( function() {
                        $(this).parent().addClass('focus');
                    })
                    .blur( function() {
                        $(this).parent().removeClass('focus');
                    })
                    .on('update_only', function() {
                        var text = $('option:selected', this).text();
                        $backdrop.text(text);
                    });
            }
        });
    };

})(jQuery);
